module.exports = __webpack_public_path__ + "media/application/images/external-services/xero-logo-ea401a655ee94475238239acb7803f95.svg";